import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
import { SingleStepTeamFragmentDoc } from '../fragments/SingleStepTeam.fragment';
export type GetSingleStepTeamQueryVariables = Types.Exact<{
	fullPath: Types.Scalars['String']['input'];
	site?: Types.InputMaybe<Types.Scalars['String']['input']>;
	country: Types.Scalars['Country']['input'];
	language: Types.Scalars['Language']['input'];
	filter?: Types.InputMaybe<Types.SportEventFilter>;
	timezoneOffset: Types.Scalars['Int']['input'];
	bucketSize: Types.Scalars['Int']['input'];
	platform: Types.Platform;
	first: Types.Scalars['Int']['input'];
	sortOrder?: Types.SortOrder;
}>;

export type GetSingleStepTeamQuery = {
	__typename?: 'Query';
	urlV2: {
		__typename?: 'Url';
		id: string;
		urlID: number;
		node:
			| { __typename?: 'Article' }
			| { __typename?: 'Author' }
			| { __typename?: 'Bundle' }
			| { __typename?: 'Device' }
			| { __typename?: 'Episode' }
			| { __typename?: 'GenericTitleList' }
			| { __typename?: 'Genre' }
			| { __typename?: 'HomePage' }
			| { __typename?: 'Movie' }
			| { __typename?: 'MultiStepSportEvent' }
			| { __typename?: 'Offer' }
			| { __typename?: 'OfferHistory' }
			| { __typename?: 'Package' }
			| { __typename?: 'Page' }
			| { __typename?: 'Person' }
			| { __typename?: 'ProfileV2' }
			| { __typename?: 'Season' }
			| { __typename?: 'Show' }
			| { __typename?: 'SingleStepSportEvent' }
			| { __typename?: 'SportCompetitionV2' }
			| {
					__typename?: 'SportCompetitorV2';
					id: string;
					objectType: Types.ObjectType;
					objectId: number;
					content: { __typename?: 'SportCompetitorContentV2'; name: string; iconUrl?: string | null };
					sportEventBucketsV2: {
						__typename?: 'SportEventBucketsConnectionV2';
						edges?: Array<{
							__typename?: 'SportEventBucketsEdgeV2';
							key: {
								__typename?: 'SportEventAggregationKeyV2';
								competition?: {
									__typename?: 'SportCompetitionV2';
									id: string;
									content: {
										__typename?: 'SportCompetitionContentV2';
										name: string;
										fullPath: string;
										iconUrl?: string | null;
									};
								} | null;
							};
							node: {
								__typename?: 'SportEventsConnectionV2';
								edges?: Array<{
									__typename?: 'SportEventsEdgeV2';
									node:
										| { __typename?: 'MultiStepSportEvent' }
										| {
												__typename: 'SingleStepSportEvent';
												id: string;
												objectType: Types.ObjectType;
												objectId: number;
												sport: Types.SportType;
												offerCount: number;
												content: {
													__typename?: 'SingleStepSportEventContent';
													name: string;
													status: Types.SportEventStatus;
													startAt: any;
													endAt?: any | null;
													fullPath?: string | null;
													venue?: {
														__typename?: 'SportVenue';
														venueID: number;
														name: string;
													} | null;
													competitionStage: {
														__typename?: 'SportCompetitionStageV2';
														name: Types.SportCompetitionStageName;
														number?: number | null;
													};
													pastEvents: Array<{
														__typename?: 'SingleStepSportEvent';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														sport: Types.SportType;
														competition?: {
															__typename?: 'SportCompetitionV2';
															id: string;
															objectId: number;
															objectType: Types.ObjectType;
															sport: Types.SportType;
															content: {
																__typename?: 'SportCompetitionContentV2';
																fullPath: string;
																name: string;
															};
														} | null;
														competitors: {
															__typename?: 'SingleStepSportCompetitorsV2';
															homeTeam: {
																__typename?: 'SingleStepSportCompetitorV2';
																score?: number | null;
																competitors: Array<{
																	__typename?: 'SportCompetitorV2';
																	id: string;
																	objectId: number;
																	objectType: Types.ObjectType;
																	sport: Types.SportType;
																	content: {
																		__typename?: 'SportCompetitorContentV2';
																		firstName: string;
																		fullPath?: string | null;
																		lastName: string;
																		name: string;
																		iconUrl?: string | null;
																	};
																}>;
															};
															awayTeam: {
																__typename?: 'SingleStepSportCompetitorV2';
																score?: number | null;
																competitors: Array<{
																	__typename?: 'SportCompetitorV2';
																	id: string;
																	objectId: number;
																	objectType: Types.ObjectType;
																	sport: Types.SportType;
																	content: {
																		__typename?: 'SportCompetitorContentV2';
																		firstName: string;
																		fullPath?: string | null;
																		lastName: string;
																		name: string;
																		iconUrl?: string | null;
																	};
																}>;
															};
														};
														content: {
															__typename?: 'SingleStepSportEventContent';
															name: string;
															startAt: any;
															status: Types.SportEventStatus;
															season?: {
																__typename?: 'SportSeason';
																name: string;
																seasonID: number;
															} | null;
														};
													}>;
												};
												mysportlistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												competition?: {
													__typename?: 'SportCompetitionV2';
													id: string;
													objectId: number;
													sport: Types.SportType;
													activeSeason?: {
														__typename?: 'SportSeason';
														name: string;
														seasonID: number;
													} | null;
													content: {
														__typename?: 'SportCompetitionContentV2';
														name: string;
														fullPath: string;
														iconUrl?: string | null;
													};
												} | null;
												competitors: {
													__typename?: 'SingleStepSportCompetitorsV2';
													homeTeam: {
														__typename?: 'SingleStepSportCompetitorV2';
														score?: number | null;
														winner: boolean;
														competitors: Array<{
															__typename?: 'SportCompetitorV2';
															id: string;
															objectId: number;
															content: {
																__typename?: 'SportCompetitorContentV2';
																name: string;
																iconUrl?: string | null;
																fullPath?: string | null;
															};
														}>;
													};
													awayTeam: {
														__typename?: 'SingleStepSportCompetitorV2';
														score?: number | null;
														winner: boolean;
														competitors: Array<{
															__typename?: 'SportCompetitorV2';
															id: string;
															objectId: number;
															content: {
																__typename?: 'SportCompetitorContentV2';
																name: string;
																iconUrl?: string | null;
																fullPath?: string | null;
															};
														}>;
													};
												};
												watchNowOffer?: {
													__typename?: 'SportOffer';
													monetizationType: Types.MonetizationType;
													presentationType: Types.PresentationType;
													audioLanguage?: string | null;
													standardWebURL?: string | null;
													sportObjectType: Types.SportObjectType;
													package: {
														__typename?: 'Package';
														id: string;
														packageId: number;
														technicalName: string;
														clearName: string;
														shortName: string;
														monetizationTypes: Array<Types.MonetizationType>;
														iconWide: string;
													};
												} | null;
												offers: Array<{
													__typename?: 'SportOffer';
													monetizationType: Types.MonetizationType;
													presentationType: Types.PresentationType;
													audioLanguage?: string | null;
													standardWebURL?: string | null;
													sportObjectType: Types.SportObjectType;
													package: {
														__typename?: 'Package';
														id: string;
														packageId: number;
														technicalName: string;
														clearName: string;
														shortName: string;
														monetizationTypes: Array<Types.MonetizationType>;
													};
												}>;
										  };
								}> | null;
							};
						}> | null;
					};
			  }
			| { __typename?: 'SportMatch' }
			| { __typename?: 'Url' };
	};
};

export const GetSingleStepTeamDocument = gql`
	query GetSingleStepTeam(
		$fullPath: String!
		$site: String
		$country: Country!
		$language: Language!
		$filter: SportEventFilter
		$timezoneOffset: Int!
		$bucketSize: Int!
		$platform: Platform!
		$first: Int!
		$sortOrder: SortOrder! = ASC
	) {
		urlV2(fullPath: $fullPath, site: $site) {
			id
			urlID
			node {
				...SingleStepTeam
			}
		}
	}
	${SingleStepTeamFragmentDoc}
`;
